module.exports = __webpack_public_path__ + "img/bg.73fc18a0.jpg";